<!--  -->
<template>
  <div class="allbox">
    <div class="serch_box">
      <div>
        <el-input v-model="obj.templateName" style="width:200px" placeholder="请输入内容" />
        <el-select v-model="obj.onlyMe" placeholder="请选择" style="margin-left:20px">
          <el-option
            v-for="item in accountarr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-button type="primary" style="margin-left:10px" icon="el-icon-search" @click="menulist()">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh" @click="menureset">重置</el-button>
      </div>
      <div>
        <el-button type="success" icon="el-icon-plus" style="margin-left:10px" @click="addmenu">新增</el-button>
      </div>
    </div>
    <el-table
      :data="tableData.list"
      border
      style="width: 100%"
    >
      <!-- <el-table-column
        prop="id"
        label="ID"
        width="180"
        align="center"
      /> -->
      <el-table-column
        prop="platform_str"
        label="平台"
        width="230"
        align="center"
      />
      <el-table-column
        prop="templateName"
        label="菜单名称"
        width="230"
        align="center"
      />
      <el-table-column
        prop="statusStr"
        label="状态"
        width="130"
        align="center"
      >
        <template slot-scope="scope">
          <i v-if="scope.row.status == 1" class="el-icon-success defaultr" />
          {{ scope.row.statusStr }}
        </template>
      </el-table-column>
      <el-table-column
        prop="normal_menu"
        label="菜单类型"
        width="150"
        align="center"
      />
      <el-table-column
        prop="realName"
        label="创建人"
        width="130"
        align="center"
      />
      <el-table-column
        prop="createdAtText"
        label="创建时间"
        width="230"
        align="center"
      />

      <el-table-column
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button type="success" size="mini" @click="bindingofficialaccount(scope.row.id)">绑定公众号</el-button>
          <el-button type="info" size="mini" @click="bindingacclist(scope.row.id)">查看绑定公众号记录</el-button>
          <el-button type="warning" size="mini" @click="multiplexing(scope.row.id)">复用</el-button>
          <el-button type="primary" size="mini" @click="lookr(scope.row.id)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :total="tableData.total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      title="绑定公众号"
      :visible.sync="dialogTableVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
    >
      <MenubindaccountDialog ref="bindaccout" @closedialog="closedialogone" @closeAndB="closeAndB" />
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="AandBdialogVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
      :destroy-on-close="true"
      width="50%"
    >
      <bandAandB ref="bandAandBview" @saveupdata="saveupdata" />
    </el-dialog>
    <el-dialog
      title="查看绑定公众号记录"
      :visible.sync="lookdialogTableVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      width="65%"
    >
      <bandingacclist ref="bindaccoutlist" @updata="updata" />
    </el-dialog>
  </div>
</template>

<script>
import { menutemplatelist } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import MenubindaccountDialog from './components/MenubindaccountDialog'
import bandingacclist from './components/bandingacclist.vue'
import bandAandB from '../customerServicelist/components/bandAandB.vue'
export default {
  components: {
    PaginationRight,
    MenubindaccountDialog,
    bandingacclist,
    bandAandB
  },
  data() {
    return {
      dialogTableVisible: false, // 弹窗显示 隐藏
      lookdialogTableVisible: false,
      tableData: [], // 表格数组
      obj: { // 表格参数
        page: 1,
        pageSize: 10,
        onlyMe: 2,
        templateName: null
      },
      AandBdialogVisible: false,
      accountarr: [{
        value: 1,
        label: '组内'
      }, {
        value: 2,
        label: '我关联的'
      }]
    }
  },
  activated() {
    this.menulist()
  },
  created() {
    this.menulist()
  },
  mounted() {

  },
  methods: {
    updata() {
      this.lookdialogTableVisible = false
      this.menulist()
    },
    saveupdata() {
      this.AandBdialogVisible = false
      this.menulist()
    },
    // 加载表格数据
    async menulist() {
      const data = await menutemplatelist(this.obj)
      this.tableData = data.data
      console.log('data', data)
    },

    // 点击绑定公众号
    bindingofficialaccount(id) {
      this.dialogTableVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.bindaccout.send(id, 3)
      }, 100)
    },
    bindingacclist(id) {
      this.lookdialogTableVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.bindaccoutlist.send(id)
      }, 100)
    },
    // 复用
    multiplexing(id) {
      this.$router.push({ path: '/menumanagement/index', query: { deviceId: id, type: 0 }})
    },
    lookr(id) {
      this.$router.push({ path: '/menumanagement/index', query: { deviceId: id, type: 1 }})
    },
    // 分页
    fetchPageSize(e) {
      this.obj.pageSize = e
      this.menulist()
    },
    fetchCurrentPage(e) {
      this.obj.page = e
      this.menulist()
    },
    menureset() {
      this.obj = {
        page: 1,
        pageSize: 10,
        templateName: null
      }
      this.menulist()
    },
    addmenu() {
      this.$router.push({ path: '/menumanagement/index', query: { type: 0 }})
    },
    closedialogone() {
      this.dialogTableVisible = false
      this.menulist()
    },
    closeAndB(val, strategy_no, arrsw) {
      this.dialogTableVisible = false
      this.AandBdialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.bandAandBview.send(val, strategy_no, arrsw, 2)
      }, 100)
    }
  }
}
</script>
<style scoped lang="less">
/* @import url(); 引入css类 */
.allbox{
  padding: 30px;
}
.que_box{
  margin-top: 50px;
}
.have{
  color: #409eff;
}
.serch_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.search_icon{
  margin-left: 10px;
}
.band_box{
  display: flex;
}
.choses_box{
  margin-bottom: 10px;
}
.select_box{
  height: 14px;
  width: 14px;
  border-radius: 3px;
  border: 1px solid skyblue;
  margin-right: 7px;
}
.choose_block{
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}
.choose_blockr{
  background: #409eff;
}
.rigboxr{
  margin-left: 200px;
}
.choiceofficialaccount{
  margin-bottom: 10px;
}
.select_spacing{
  margin-bottom: 5px;
}
.defaultrse{
  color: #E6A23C;
}
.defaultr{
  color: #67C23A;
}
.stopew{
  color: red;
}
.fasrw{
  color: #409EFF;
}
</style>
